import { HatchCoverMoveDto } from '@operations/app/api'
import { SelectOption } from '@operations/app/models'

export interface HatchcoverFilter {
  equipmentName?: SelectOption | null | number
  direction?: HatchCoverMoveDto['direction'] | null
}
export const defaultValues: HatchcoverFilter = {
  equipmentName: null,
  direction: null,
}
